<template>
	<div id="AdvertisementsDashboard">
		<dashboardMenu @updateCategories="[]" />

		<alertConfirmAction
			v-if="toggleAlertConfirmAction"
			:confirmText="'Excluir'"
			@confirmAction="removeAdvertise"
			@cancelAction="cancelRemoveAdvertise"
		>
			<h5 slot="title">Excluir publicidade?</h5>
			<p slot="text">Deseja realmente remover este conteúdo?</p>
		</alertConfirmAction>

		<div class="container pt-5">
			<div class="row mb-4 align-items-center">
				<div class="col row">
					<h3 class="mb-0 ml-3">Minhas publicidades</h3>
				<div class="item-settings-button" @click="modalTitle()">
					<span class="pointer">
						<i class="fal fa-cog"></i>
					</span>
				</div>
				</div>
				<div class="col-12 col-md-auto">
					<span
						class="pointer btn btn-primario py-2"
						@click="newAdvertisementHandler"
					>
						<i class="fal fa-plus"></i> Nova
					</span>
				</div>
			</div>

			<div v-if="advertisements.length == 0">
				<p>
					Você ainda não possui publicidades cadastradas. Clique no
					botão "Novo" para criar um novo anúncio.
				</p>
			</div>

			<div class="row" v-else>
				<div
					class="col-12 col-md-6 mb-3"
					v-for="(item, index) in advertisements"
					:key="index"
				>
					<div class="card advertise-card">
						<div class="card-body py-3 d-flex">
							<div class="advertise-thumbnail">
								<template
									v-if="item.advertisementType == 'banner'"
								>
									<img
										class="img-fluid"
										:src="item.image | urlComplete"
									/>
								</template>
								<template v-else-if="item.advertisementType == 'text'">
									<i class="fas fa-text fa-3x"></i>
								</template>
								<template v-else>
									<i class="fas fa-code fa-3x"></i>
								</template>
							</div>
							<div class="advertise-data">
								<div class="d-flex justify-content-between">
									<h5>{{ item.title }}</h5>
									<div class="item-settings-button" @click="editAdvertisementHandler(item,index)">
										<span ><i class="fal fa-pencil-alt"></i></span>
									</div>
								</div>
								<p v-if="item.advertisementType == 'banner'">
									<strong>Url:</strong>
									<a
										:href="item.ref"
										target="_blank"
										rel="noopener noreferrer"
										v-if="item.ref"
										>{{ item.ref }}</a
									>
									<span v-else>-</span>
								</p>
								<p v-if="item.advertisementType == 'script'">
									<strong>Script:</strong>
									{{ item.content }}
								</p>
								<div
									class="m-0 d-flex justify-content-between align-items-center"
								>
									<span
										@click="toggleAdvertise(item)"
										v-if="item.status == 1"
										class="pointer toggle-on"
									>
										<i
											class="fal fa-toggle-on fa-2x text-success"
										></i>
									</span>
									<span
										@click="toggleAdvertise(item)"
										v-else
										class="pointer toggle-off"
									>
										<i
											class="fal fa-toggle-off fa-2x opacity-50"
										></i>
									</span>
									<div class="item-settings-button" @click="handleRemoveAdvertise(index)">
										<span ><i class="fal fa-trash-alt"></i></span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!--<div class="row">
        <div class="col-12">
          <p>Utilize este recurso para cadastrar selos de patrocínio, banners de afiliados ou scripts de anunciantes.</p>
        </div>
      </div>-->

			<b-modal
				ref="advertisementTitle"
				id="advertisementTitle"
				centered
				hide-footer
				title="Escolha os títulos da publicidade:"
			>
				<b-container >
						<div class="row justify-content-between">
							<div 
								class="col-12 form-group"
								v-for="position in positionList"
								:key="position.value" 
							>
								
								<label for="advertisementTitle">{{ position.text }}</label>
								<input
									type="text"
									:id="position.value"
									class="form-control"
									v-model="position.title"
								/>
							</div>
							<div class="col-auto align-self-center">
								<span
									class="pointer py-2"
									@click="$bvModal.hide('advertisementTitle')"
									>Cancelar</span
								>
							</div>
							<div class="col-auto">
								<button
									class="btn btn-primario py-2"
									@click="saveTitles(positionList)"
								>
									Salvar
								</button>
							</div>
						</div>
				</b-container>
			</b-modal>

			<div v-if="showMediaManager">
				<media-manager
					:picsInGallery="[...newAdvertise.image]"
					:maxItemSelected="1"
					@receiveMedias="addPictures($event)"
					@closeTabs="closeTabs()"
				/>
			</div>
			
			<b-modal
				ref="advertisementModal"
				id="advertisementModal"
				centered
				hide-footer
				title="Adicionar publicidade"
				@hidden="clearModal"
			>
				<b-container v-if="!activeItem">
					<form action @submit.prevent="addAdvertise">
						<div class="row justify-content-between">
							<div class="col-12 form-group">
								<label for="newAdivertiseTitle">Título</label>
								<input
									type="text"
									id="newAdivertiseTitle"
									class="form-control"
									v-model="newAdvertise.title"
									required
								/>
							</div>
							<div class="col-12 form-group">
								<label for="newAdivertsePosition"
									>Posição da publicidade</label
								>
								<select
									v-model="newAdvertise.position"
									class="form-control"
									required
								>	
									<option v-if="!hasPosition('menu')" value="menu">Topo menu</option>
									<option value="after_content">Depois do Conteúdo</option>
									<option value="footer">Rodapé</option>
									<option value="sidebar">Menu lateral</option>
								</select>
							</div>
							<div class="col-12 form-group">
								<label for="newAdivertseType"
									>Tipo de publicidade</label
								>
								<select
									name
									id
									v-model="newAdvertise.advertisementType"
									class="form-control"
									required
								>
									<option v-if="newAdvertise.position == 'menu'" value="text">Texto</option>
									<option value="banner">Imagem</option>
									<option value="script">
										Código incorporado
									</option>
								</select>
							</div>
							<template
								v-if="
									newAdvertise.advertisementType == 'script'
								"
							>
								<div class="col-12 form-group">
									<label for="newAdivertiseContent"
										>Código Incorporado</label
									>
									<textarea
										name
										id
										cols="30"
										rows="4"
										class="form-control"
										v-model="newAdvertise.content"
										required
									></textarea>
								</div>
							</template>
							<template
								v-else-if="
									newAdvertise.advertisementType == 'text'
								"
							>
								<div class="col-12 form-group">
									<label for="newAdivertiseContent"
										>Texto</label
									>
									<textarea
										name
										id
										cols="30"
										rows="4"
										class="form-control"
										v-model="newAdvertise.content"
										required
									></textarea>
								</div>
							</template>
							<template v-else>
								<div
									class="col-12 col-md-4 add-image-container"
								>
									<span
										v-if="!newAdvertise.image"
										class="add-image-span pointer text-center"
										@click="addImage"
									>
										<template v-if="uploadLoading == false">
											<i class="fal fa-camera fa-2x"></i>
											<br />Enviar
										</template>
										<template v-else>
											<i
												class="fal fa-spinner fa-spin fa-2x"
											></i>
										</template>
									</span>
									
									<img
										:src="newAdvertise.image | urlComplete"
										alt
										class="img-fluid"
										v-else
									/>
								</div>
								<div class="col-12 col-md-8 form-group">
									<label for="urlImage">Url</label>
									<input
										type="url"
										name
										id="urlImage"
										v-model="newAdvertise.ref"
										class="form-control"
									/>
								</div>
								<div class="col-12" v-if="errorImage">
									<span class="error-message">
										<small>Imagem obrigatória</small>
									</span>
								</div>
							</template>
							<div class="col-auto align-self-center">
								<span
									class="pointer py-2"
									@click="$bvModal.hide('advertisementModal')"
									>Cancelar</span
								>
							</div>
							<div class="col-auto">
								<button
									class="btn btn-primario py-2"
									:disabled="saving ? true : false"
								>
									<i
										v-if="saving"
										class="fal fa-spinner fa-spin fa-2x"
									></i>
									<span v-else >Salvar</span> 
								</button>
							</div>
						</div>
					</form>
				</b-container>
        
				<b-container v-else>
					<form action @submit.prevent="updateAdvertise(activeItem)">
						<div class="row justify-content-between">
							<div class="col-12 form-group">
								<label for="editAdivertiseTitle">Título</label>
								<input
									type="text"
									id="editAdivertiseTitle"
									class="form-control"
									v-model="activeItem.title"
									required
								/>
							</div>
							<div class="col-12 form-group">
								<label for="editAdivertsePosition"
									>Posição da publicidade</label
								>
								<select
									v-model="activeItem.position"
									class="form-control"
									required
								>
									<option 
                    v-for="position in positionList"
                    :key="position.value" 
                    :value="position.value" 
                    :selected="activeItem.position == position.value ? true : false">
                    {{ position.text }}
                  </option>
								</select>
							</div>
							<div class="col-12 form-group">
								<label for="editAdivertseType"
									>Tipo de publicidade</label
								>
								<select
									name
									id
									v-model="activeItem.advertisementType"
									class="form-control"
									required
								>
									<option value="text">Texto</option>
									<option value="banner">Imagem</option>
									<option value="script">
										Código incorporado
									</option>
								</select>
							</div>
							<template
								v-if="
									activeItem.advertisementType == 'script'
								"
							>
								<div class="col-12 form-group">
									<label for="editAdivertiseContent"
										>Código Incorporado</label
									>
									<textarea
										name
										id
										cols="30"
										rows="4"
										class="form-control"
										v-model="activeItem.content"
										required
									></textarea>
								</div>
							</template>
							<template
								v-else-if="
									activeItem.advertisementType == 'text'
								"
							>
								<div class="col-12 form-group">
									<label for="editAdivertiseContent"
										>Texto</label
									>
									<textarea
										name
										id
										cols="30"
										rows="4"
										class="form-control"
										v-model="activeItem.content"
										required
									></textarea>
								</div>
							</template>
							<template v-else>
								<div
									class="col-12 col-md-4 add-image-container"
								>
									<span
										v-if="!activeItem.image"
										class="add-image-span pointer text-center"
										@click="addImage"
									>
										<template v-if="uploadLoading == false" >
											<i class="fal fa-camera fa-2x"></i>
											<br />Enviar
										</template>
										<template v-else>
											<i
												class="fal fa-spinner fa-spin fa-2x"
											></i>
										</template>
									</span>
                  <template v-else>
											<i v-if="uploadLoading"
												class="fal fa-spinner fa-spin fa-2x"
											></i>
                    <img
                      v-else
                      @click="addImage"
                      :src="activeItem.image | urlComplete"
                      alt
                      class="img-fluid pointer"
                    />
                  </template>
								</div>
								<div class="col-12 col-md-8 form-group">
									<label for="urlImage">Url</label>
									<input
										type="url"
										name
										id="urlImage"
										v-model="activeItem.ref"
										class="form-control"
									/>
								</div>
								<!-- <div class="col-12" v-if="errorImage">
									<span class="error-message">
										<small>Imagem obrigatória</small>
									</span>
								</div> -->
							</template>
							<div class="col-auto align-self-center">
								<span
									class="pointer py-2"
									@click="$bvModal.hide('advertisementModal')"
									>Cancelar</span
								>
							</div>
							<div class="col-auto">
								<button
									class="btn btn-primario py-2"
									:disabled="saving ? true : false"
								>
									<i
										v-if="saving"
										class="fal fa-spinner fa-spin fa-2x"
									></i>
									<span v-else >Salvar</span> 
								</button>
							</div>
						</div>
					</form>
				</b-container>
			</b-modal>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	import apiMixins from "@/mixins/apiMixins";
	import dashboardMenu from "@/components/DashboardMenu";
	import alertConfirmAction from "@/components/organisms/AlertConfirmAction";
	import MediaManager from '../organisms/MediaManager.vue';

	export default {
		name: "AdvertisementsDashboard",
		data() {
			return {
				showMediaManager: false,
				toggleAlertConfirmAction: false,
				itemToRemove: null,
				isLoaded: false,
				errorLoad: false,
				errorImage: false,
				saving: false,
				file: null,
				uploadLoading: false,
				advertisements: [],
				newAdvertise: {
					title: "",
					advertisementType: "banner",
					position: "footer",
					content: "",
					ref: "",
					image: "",
				},
        activeItem: null,
        activeItemIndex: null,
        positionList: []
			};
		},
		mixins: [apiMixins],
		components: {
			dashboardMenu,
			alertConfirmAction,
			MediaManager,
		},
		filters: {
			urlComplete(value) {
				return `${process.env.CDN_URL}${value}`;
			},
		},
		methods: {
			closeTabs() {
				this.showMediaManager = false;
			},
			addPictures(pictures) {
				if (!this.activeItem) {
					this.newAdvertise.image = pictures[0].url;
				} else {
					this.activeItem.image = pictures[0].url;
				}

				this.showMediaManager = false;
			},
			hasPosition(value){
				if (this.advertisements.filter(el => el.position == value).length > 0) return true
				return false
			},
			async saveTitles(positionList){
				let data = {}
				positionList.forEach((position) => {
					let value = position.value
					let title = position.title
					data[value] = title
				});
				const url = `/site/${this.$session.get("siteId")}/flyer/titles/update`;
				const statusRequest = await this.requestApiData(url, "post",data);
				if (!statusRequest.status == "1") {
					alert("Erro ao atualizar status do anúncio");
				}
				this.$refs.advertisementTitle.hide()
			},
      verifySelected(){
        setTimeout(() => {
          return "selected"
        }, 1000);
      },
			clearModal() {
				this.newAdvertise = {
					title: "",
					advertisementType: "banner",
					position: "footer",
					content: "",
					ref: "",
					image: "",
				};
				this.saving = false;
			},
			async toggleAdvertise(item) {
				let advertiseItem = item
				const url = `/site/${this.$session.get("siteId")}/flyer/${
					item.id
				}/update`;
				advertiseItem.status = item.status == 1 ? 0 : 1
				const statusRequest = await this.requestApiData(url, "post",advertiseItem);
				if (statusRequest.status == "1") {
					item.status = statusRequest.data.status;
				} else {
					alert("Erro ao atualizar status do anúncio");
				}
			},
			handleRemoveAdvertise(index) {
				this.itemToRemove = index;
				this.toggleAlertConfirmAction = true;
			},
			async removeAdvertise() {
				const itemId = this.advertisements[this.itemToRemove].id;
				const url = `/site/${this.$session.get(
					"siteId"
				)}/flyer/${itemId}/delete`;
				const statusRequest = await this.requestApiData(url, "post");
				if (statusRequest.status == "1") {
					this.advertisements.splice(this.itemToRemove, 1);
				} else {
					alert("Erro ao atualizar status do anúncio");
				}
				this.toggleAlertConfirmAction = false;
				this.itemToRemove = null;
			},
			cancelRemoveAdvertise() {
				this.itemToRemove = null;
				this.toggleAlertConfirmAction = false;
			},
			modalTitle() {
				this.$refs.advertisementTitle.show();
			},
			editAdvertisementHandler(item,index) {
				this.activeItem = item
				this.$refs.advertisementModal.show();
			},
			newAdvertisementHandler() {
        this.activeItem = null;
        this.activeItemIndex = null;
				this.$refs.advertisementModal.show();
			},
			addImage() {
				this.showMediaManager = true;
			},
			submitFile() {
				const siteId = this.$session.get("siteId");
				const token = this.$session.get("jwt");
				let formData = new FormData();
				formData.append("image", this.file);
				axios({
					method: "post",
					url: `${process.env.ROOT_API}api/site/${siteId}/image/upload`,
					data: formData,
					headers: {
						Authorization: "Bearer " + token,
						// 'Content-Type': 'application/x-www-form-urlencoded'
					},
				})
					.then((response) => {
            if(this.activeItem){
              this.activeItem.image = response.data.url;
            }
            else{
						  this.newAdvertise.image = response.data.url;
            }
						this.uploadLoading = false;
					})
					.catch(function () {
						alert("Falha ao enviar imagem, tente novamente");
						this.uploadLoading = false;
					});
				this.file = "";
			},
      async updateAdvertise(item){
        this.errorImage = false;
				const url = `/site/${this.$session.get("siteId")}/flyer/${
					item.id
				}/update`;
				this.saving = true;
				const statusRequest = await this.requestApiData(url, "post",item);
				if (statusRequest.status == "1") {
				} else {
					alert("Erro ao atualizar status do anúncio");
				}
				this.$refs.advertisementModal.hide();
				this.saving = false;
      },
			async addAdvertise() {
				this.errorImage = false;
				const url = `/site/${this.$session.get("siteId")}/flyer/create`;
				if (
					!this.newAdvertise.image &&
					this.newAdvertise.advertisementType === "banner"
				) {
					this.errorImage = true;
				} else {
					this.saving = true;
					const newAdvertise = await this.requestApiData(
						url,
						"post",
						this.newAdvertise
					);
					this.advertisements.push(newAdvertise.data);
					this.$refs.advertisementModal.hide();
				}
			},
			getSiteAdvertisements() {
				const siteId = this.$session.get("siteId");
				const token = this.$session.get("jwt");
				axios({
					method: "get",
					url: `${process.env.ROOT_API}api/site/${siteId}/flyer`,
					headers: {
						Authorization: "Bearer " + token,
						// 'Content-Type': 'application/x-www-form-urlencoded'
					},
				}).then((response) => {
					if (response.data.status == "1") {
						this.advertisements = response.data.data;
						this.positionList = [
							{value:'after_content',text:'Depois do Conteúdo',title: response.data.titles.after_content},
							{value:'footer',text:'Rodapé',title:response.data.titles.footer},
							{value:'sidebar',text:'Menu lateral',title:response.data.titles.sidebar},
							{value:'menu',text:'Menu Topo',title:response.data.titles.menu}
						];
					}
				});
			},
		},
		created() {
			this.$store.dispatch("VERIFY_TOKEN");
			//this.$store.dispatch("VERIFY_SITE");
			this.getSiteAdvertisements();
		},
	};
</script>

<style scoped>
	.add-image-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-color: white;
	}
	.add-image-container img {
		object-fit: cover;
	}
	.add-image-span {
		background-color: #f2f2f2;
		color: #858585;
		padding: 14px 39px;
		font-weight: 700;
	}
	.advertise-thumbnail {
		display: flex;
		width: 33%;
		min-height: 90px;
		padding: 0 10px;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #858585;
	}
	.advertise-data {
		font-size: 0.8rem;
		display: flex;
		flex-direction: column;
		width: 65%;
		min-height: 90px;
	}
	.remove-button {
		font-size: 1rem;
		color: #858585;
		transition: all 300ms;
	}
	.remove-button:hover {
		color: var(--error-color);
	}
	.toggle-off {
		color: #858585;
		transition: all 300ms;
	}
</style>


// WEBPACK FOOTER //
// src/components/templates/AdversimentsDashboard.vue